import { useEffect } from 'react'
import { Link, NavLink } from 'react-router'
import { RiCloseLine } from 'react-icons/ri'
import { cn } from '@/lib/cn'
import { ROUTES } from '@/constants/routes'
import logoSrc from '@/assets/logo/logo.png'

const navLinks = [
  { to: ROUTES.HOME, label: 'Home', end: true },
  { to: ROUTES.ABOUT, label: 'About Simone', end: false },
  { to: ROUTES.SERVICES, label: 'Services', end: false },
  { to: ROUTES.HER_JOURNEY_HUB, label: 'Journey Hub', end: false },
  { to: ROUTES.STORIES, label: 'Stories', end: false },
  { to: ROUTES.FAQ, label: 'FAQ', end: false },
  { to: ROUTES.ENQUIRY, label: 'Enquiry', end: false },
]

interface MobileMenuProps {
  open: boolean
  onClose: () => void
}

export const MobileMenu = ({ open, onClose }: MobileMenuProps) => {
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  return (
    <>
      {/* Backdrop */}
      {open && (
        <div
          aria-hidden="true"
          onClick={onClose}
          className="fixed inset-0 z-[59] bg-black/45 backdrop-blur-sm"
        />
      )}

      {/* Drawer */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Navigation menu"
        className={cn(
          'fixed top-0 right-0 bottom-0 z-[60] w-[min(320px,90vw)]',
          'bg-white flex flex-col p-6',
          'shadow-[-8px_0_40px_rgba(26,21,16,0.12)]',
          'transition-transform duration-[350ms] ease-[cubic-bezier(0.4,0,0.2,1)]',
          open ? 'translate-x-0' : 'translate-x-full',
        )}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <Link to={ROUTES.HOME} onClick={onClose}>
            <img src={logoSrc} alt="H.E.R Birth Keeper" className="h-12 w-auto" />
          </Link>
          <button className="nav-toggle-btn" onClick={onClose} aria-label="Close menu">
            <RiCloseLine size={24} />
          </button>
        </div>

        {/* Links */}
        <nav className="flex-1 flex flex-col gap-1">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => cn('nav-mobile-link', isActive && 'active')}
              onClick={onClose}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        {/* CTA */}
        <div className="pt-7 border-t border-base-200">
          <Link to={ROUTES.ENQUIRY} className="nav-cta nav-cta--full" onClick={onClose}>
            Book Your Free Call
          </Link>
          <p className="mt-4 text-xs text-base-500 text-center leading-relaxed font-body">
            Essex · North Kent · East London
          </p>
        </div>
      </div>
    </>
  )
}
